import apiClient from '../../../common/services/apiClient';

export const apiCallIds = {
  WITHDRAW_FUNDS: 'WITHDRAW_FUNDS',
  FETCH_PAYMENTS: 'FETCH_PAYMENTS',
  PROVISON_FEE_WITHDRAW: 'PROVISON_FEE_WITHDRAW',
};

export default {
  withdrawFunds: (accountId, amount) => {
    return apiClient.post(
      `/account/${accountId}/withdrawFunds`,
      { amount },
      { apiCallId: apiCallIds.WITHDRAW_FUNDS }
    );
  },

  fetchPayments: (accountId) => {
    return apiClient.get(
      `/payments/${accountId}`,
      { apiCallId: apiCallIds.FETCH_PAYMENTS }
    );
  },

  withdrawProvisionFees: body => {
    return apiClient.post(
      `/withdrawFeeAndInsurance`,
      body,
      { apiCallId: apiCallIds.PROVISON_FEE_WITHDRAW }
    )
  }
};



// WEBPACK FOOTER //
// ./src/features/payments/api/index.js